import Sidebar from "./Sidebar";

export default function Layout({ children, title, subtitle, actions }) {
  return (
    <div className="flex min-h-screen bg-zinc-50">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <header className="border-b border-zinc-200 bg-white sticky top-0 z-10">
          <div className="px-8 py-5 flex items-center justify-between">
            <div>
              <h1 className="font-display text-2xl font-extrabold tracking-tight" data-testid="page-title">{title}</h1>
              {subtitle && <p className="text-sm text-zinc-500 mt-0.5">{subtitle}</p>}
            </div>
            <div className="flex items-center gap-2">{actions}</div>
          </div>
        </header>
        <div className="px-8 py-6 max-w-[1600px]">{children}</div>
      </main>
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return <div className={`card-flat p-5 ${className}`} {...rest}>{children}</div>;
}

export function Label({ children }) {
  return <div className="label-up mb-2">{children}</div>;
}

export function Badge({ children, kind = "default", testid }) {
  const map = {
    aperta: "badge-aperta",
    contendibile: "badge-contendibile",
    compromessa: "badge-compromessa",
    default: "badge-default",
  };
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 text-xs font-medium tracking-tight rounded-sm ${map[kind] || map.default}`}>
      {children}
    </span>
  );
}

export function Spinner({ label }) {
  return <span className="inline-flex items-center gap-2 text-xs text-zinc-500"><span className="spinner" /> {label || "Caricamento..."}</span>;
}
